// extracted by mini-css-extract-plugin
module.exports = {"starColor":"_15kQRyRv","stars":"_1OKDDIBi"};